<template>
  <div class="admin-main" :class="{'collapsed__container': isCollapsed}">
    <transition name="fade">
      <div v-if="loading" class="font-loader-overlay" aria-hidden="true">
        <StatisticSkeleton/>
      </div>
    </transition>
    <Statistic v-show="side.id == 0 && !loading" :statistic="statistic" :requests="requests"/>
    <Calendar v-if="side.id == 1 && !loading" :statistic="statistic" :requests="requests"/>
    <Orders v-if="side.id == 2 && !loading" :requests="requests"/>
    <SEO v-if="side.id == 3 && !loading"/>
  </div>
</template>

<script>
import StatisticSkeleton from './StatisticSkeleton.vue'
import Statistic from './Statistic.vue'
import Calendar from './Calendar.vue'
import Orders from './Orders.vue';
import SEO from './SEO.vue'

import { mapGetters } from "vuex"

export default {
  name: 'AdminDashboard',
  components: { Statistic, StatisticSkeleton, Calendar, Orders, SEO },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    side: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      loading: true,
      ranges: [
        {
          key: 'today',
          title: 'Сегодня'
        },
        {
          key: 'last_7_days',
          title: 'За 7 дней'
        },
        {
          key: 'current_week',
          title: 'За неделю'
        },
        {
          key: 'current_month',
          title: 'За месяц'
        },
        {
          key: 'last_90_days',
          title: 'За 90 дней'
        },
        {
          key: 'current_year',
          title: 'За год'
        },
        {
          key: 'all_time',
          title: 'За все время'
        }
      ],
    };
  },
  computed: {
    ...mapGetters("statistic", ["statistic"]),
    ...mapGetters("statistic", ["requests"]),
  },
  methods: {
    openLead () {

    },  
    getRangeTitle (key) {
      return this.ranges.find(item => item.key == key)?.title
    },
  },
  created () {
  },
  async mounted() {
    await this.$store.dispatch(
      'statistic/GET_STATISTIC', 
      {
        landing_settings_uid: this.$store.getters['landing/landingSettings'].uid
      }
    )
    await this.$store.dispatch(
      'statistic/GET_REQUESTS_BY_LANDING_SETTINGS_UID',
      {
        landing_settings_uid: this.$store.getters['landing/landingSettings'].uid
      }
    )
    this.loading = false
  }
};
</script>

<style scoped>
.admin-main {
  width: calc(100% - 17rem);
  transition: 0.3s ease all;
}
.collapsed__container {
  width: calc(100% - 4rem);
}
</style>